import {useEffect, useState} from 'react'
import {refreshIfStale} from './api/client'
import {useApiToken} from './api/useApiToken'
import {initials, isDeceased, isFemale, photoOf, portraitUrl} from './api/tree'
import type {Person} from './api/types'

interface Props {
  p: Person | undefined
  size: number
  shape?: 'circle' | 'rounded'
}

/** Портрет с траурной лентой на углу, если человека уже нет.
 *  Обёртка нужна ради ленты: псевдоэлемент к <img> не прицепить. */
export default function Portrait({p, size, shape = 'circle'}: Props) {
  const jwt = useApiToken()
  const photo = photoOf(p)
  // просим втрое крупнее показанного: на плотных экранах иначе мыло
  const src = portraitUrl(p, size * 3, jwt)
  /* Миниатюра может не отдаться: главным файлом человека мог оказаться
     ролик (миниатюр у видео нет), файл могли потерять при переносе.
     Тогда показываем инициалы, а не битую картинку. */
  const [broken, setBroken] = useState(false)
  // на новом токене пробуем снова: чаще всего «сломалось» — это просто
  // протухший токен, и после обновления картинка на месте
  useEffect(() => setBroken(false), [photo, jwt])

  const cls = `por ${shape}` + (isDeceased(p) ? ' dead' : '')
  return (
    <span className={cls} style={{width: size, height: size}}>
      {src && !broken ? (
        /* Подстраховка и на протухший токен: просим обновить его, и
           картинка перерисуется с новым адресом. Обновление
           однопоточное, так что сотня разом погасших аватарок даст
           один запрос. */
        <img src={src} alt="" loading="lazy"
             onError={() => { refreshIfStale(); setBroken(true) }} />
      ) : (
        <span className={'ini' + (isFemale(p) ? ' f' : '')} style={{fontSize: Math.round(size * 0.34)}}>
          {initials(p)}
        </span>
      )}
    </span>
  )
}
